// extracted by mini-css-extract-plugin
export var audioPlayer = "_tr-0";